// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

export function getGlobalObject(): any {
  return self;
}
